/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/core';
import { useTheme } from '../../theme';
import { topLevelElementCss } from '.';
const ThematicBreak = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("div", Object.assign({}, props, { ref: ref, css: [
            topLevelElementCss,
            css `
          position: relative;
          color: ${theme.colors.paragraph.text};
          caret-color: ${theme.colors.paragraph.text};

          &::before {
            content: '';
            position: absolute;
            top: 1em;
            width: 100%;
            height: 2px;
            background-color: ${theme.colors.thematicBreak};
          }
        `,
        ] })));
});
ThematicBreak.displayName = 'ThematicBreak';
export default React.memo(ThematicBreak);
//# sourceMappingURL=ThematicBreak.js.map